import React from "react";
import InputControl from "./InputControl";
import SelectControl from "./SelectControl";

interface LinkValue {
  text: string;
  link: string;
  target?: string;
}

interface LinkFormControlProps {
  idPrefix: string;
  value: LinkValue;
  onChange: (field: keyof LinkValue, value: string) => void;
  disabled?: boolean;
  errors?: {
    text?: string;
    link?: string;
    target?: string;
  };
  required?: boolean;
}

/**
 * Form control for managing link data (URL, text, target)
 */
const LinkFormControl: React.FC<LinkFormControlProps> = ({
  idPrefix,
  value,
  onChange,
  disabled = false,
  errors = {},
  required = false,
}) => {
  const targetOptions = [
    { value: "internal", label: "Internal" },
    { value: "_self", label: "Same window" },
    { value: "_blank", label: "New window" },
    { value: "_embed", label: "Video Embed" },
  ];

  return (
    <div className="space-y-3">
      <InputControl
        id={`${idPrefix}-text`}
        label="Link Text"
        value={value.text}
        onChange={(e) => onChange("text", e.target.value)}
        placeholder="Enter link text"
        disabled={disabled}
        error={errors.text}
        required={required}
      />

      <InputControl
        id={`${idPrefix}-link`}
        label="Link URL"
        value={value.link}
        onChange={(e) => onChange("link", e.target.value)}
        placeholder="Enter URL (e.g., /path or https://example.com)"
        disabled={disabled}
        error={errors.link}
        required={required}
      />

      <SelectControl
        id={`${idPrefix}-target`}
        label="Open in"
        value={value.target || "_self"}
        onChange={(e) => onChange("target", e.target.value)}
        options={targetOptions}
        disabled={disabled}
        error={errors.target}
      />
    </div>
  );
};

export default LinkFormControl;
